import { Component, inject, signal, OnInit, DestroyRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';
import { ApiKey, DefaultService } from 'src/app/utils/api';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-api-keys',
    standalone: false,
    templateUrl: './api-keys.component.html',
    styleUrl: './api-keys.component.scss'
})
export class ApiKeysComponent implements OnInit {
    configService = inject(ConfigService);
    defaultService = inject(DefaultService);
    router = inject(Router);
    destroyRef = inject(DestroyRef);
    toastr = inject(ToastrService);

    appOverviewUrl = this.configService.getConfig().appOverviewUrl;
    ready = signal(false);
    loading = signal(false);
    submitting = signal(false);

    deleteApiKeyId = signal<string | undefined>(undefined);
    apiKeys = signal<ApiKey[]>([]);
    apiKeyPlaceholder = Array(28).fill(0);

    ngOnInit() {
        this.getApiKeys();

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe({
                next: (next: NavigationEnd) => {
                    if (next.urlAfterRedirects === '/meldpunt/api-keys') {
                        this.loading.set(true);
                        this.getApiKeys();
                    }
                }
            });
    }

    private getApiKeys() {
        this.defaultService.apikeysGetApiKeys().subscribe({
            next: (next) => {
                this.apiKeys.set(next);
                this.ready.set(true);
                this.loading.set(false);
            }
        });
    }

    deleteKey(id: string) {
        this.submitting.set(true);
        this.defaultService.apikeysDeleteApiKey(id).subscribe({
            next: (next) => {
                this.submitting.set(false);
                this.toastr.success('Api key werd succesvol verwijderd.', 'Api key verwijderd');
                this.getApiKeys();
            },
            error: (error) => {
                this.submitting.set(false);
                this.toastr.success('Api kon niet worden verwijderd.', 'Verwijderen mislukt');
            }
        });
    }
}
